package pt.at.oss.kotlin.manual.validator.nonunionform

import pt.at.oss.kotlin.manual.schema.nonunionform.NonUnionFormSchema
import pt.at.oss.kotlin.manual.storage.nonunionform.NonUnionForm
import pt.at.oss.kotlin.manual.validator.common.AddressValidator
import pt.at.oss.kotlin.manual.validator.common.BankAccountInfoValidator
import pt.at.oss.kotlin.manual.validator.common.ContactInfoValidator
import pt.at.oss.kotlin.manual.validator.common.ContactNameValidator
import pt.at.oss.kotlin.manual.validator.common.CountryOfBusinessValidator
import pt.at.oss.kotlin.manual.validator.common.FreeTextValidator
import pt.at.oss.kotlin.manual.validator.common.IdentOfBusinessValidator
import pt.at.oss.kotlin.manual.validator.common.NON_UNION_NAT_TAX_VALIDATOR
import pt.at.oss.kotlin.manual.validator.common.PREV_OR_CURR_OSS_VAT_IDS_VALIDATOR
import pt.at.oss.kotlin.manual.validator.common.SupplyCommencementValidator
import pt.at.oss.kotlin.manual.validator.common.TradingNamesValidator
import pt.at.oss.kotlin.manual.validator.common.WebsitesValidator
import pt.at.oss.kotlin.manual.validator.common.validateAllowedValues
import pt.lightweightform.kotlin.type.validator.ValidationError
import pt.lightweightform.kotlin.type.validator.ValidationErrors

class NonUnionFormValidator {

    fun validate(model: NonUnionForm): ValidationErrors {
        val schemaErrors = NonUnionFormSchema().validate(model)

        if (schemaErrors.errors.isNotEmpty()) {
            return schemaErrors
        } else {
            val extraErrors = mutableListOf<ValidationError>()

            // notEstablishedInEU
            validateAllowedValues(model.notEstablishedInEU, listOf(true))
                ?.also { extraErrors.add(it) }

            // companyName
            // ->required and has max size
            FreeTextValidator.validateFreeText(model.companyName)
                ?.also { extraErrors.add(it) }

            // nationalTaxNumber
            // ->required and has max size
            NON_UNION_NAT_TAX_VALIDATOR.validateTaxRefFormat(model.nationalTaxNumber)
                ?.also { extraErrors.add(it) }

            // tradingNames
            TradingNamesValidator.tradingNamesValidate(model.tradingNames.size, model.companyName)
                ?.also { extraErrors.add(it) }
            extraErrors.addAll(model.tradingNames.mapNotNull { FreeTextValidator.validateFreeText(it.name) })

            // countryOfBusiness
            extraErrors.addAll(CountryOfBusinessValidator().validateSequencial(model.countryOfBusiness, model.cobRegion, false, false))

            // business+issuingCountry
            IdentOfBusinessValidator.validateEqualCountryAndIssuer(model.countryOfBusiness, model.cobRegion, model.issuingCountry, false)
                ?.also { extraErrors.add(it) }
            IdentOfBusinessValidator.validateIssuer(model.issuingCountry)
                ?.also { extraErrors.add(it) }

            // RFC-960 - Algumas regiões obrigam a que o cobRegion seja igual ao issuingCountry
            IdentOfBusinessValidator.validateNatTaxRefMandatoryIssuer(model.cobRegion, model.issuingCountry)
                ?.also { extraErrors.add(it) }

            // address
            extraErrors.addAll(AddressValidator().validateAddressSequencial(model.address))

            // websites
            // ->when present required and has max size
            // ->formatted correctly
            extraErrors.addAll(WebsitesValidator.validateWebsitesSequential(model.websites, true))

            // contactName
            extraErrors.addAll(ContactNameValidator.contactNameSequencialValidate(model.contactName))

            // contactInfo
            extraErrors.addAll(ContactInfoValidator.contactInfoSequencialValidate(model.contactInfo))

            // bankAccountInfo
            extraErrors.addAll(BankAccountInfoValidator.bankAccountInfoSequencialValidate(model.bankAccountInfo, true, true))

            // prevOrCurrOssVatId isoA2 and vat
            model.prevOrCurrOssVatId.forEach { prevOrCurrOssVatId ->
                extraErrors.addAll(PREV_OR_CURR_OSS_VAT_IDS_VALIDATOR.validateVatIdSequencial(prevOrCurrOssVatId))
            }

            // supplyCommencement
            extraErrors.addAll(SupplyCommencementValidator.validateSupplyCommencementSequencial(model.supplyCommencement))

            return ValidationErrors(extraErrors)
        }
    }
}
